import React, { useEffect, useState } from'react';
import { formatCurrency } from '../../tools/tool';
import {ReactComponent as WalletIcon} from '../../icons/wallet.svg';
import { adminServices } from "../../services/AdminServices"
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import TotalCashReleaseCard from './TotalCashReleaseCard';
const IPXWalletCard = ({ dateRange }) => {
    const navigate = useNavigate();
    const [walletValue, setWalletValue] = useState(0);
    const [fees, setFees] = useState(0);
    const [merchantOrders, setMerchantOrders] = useState(0);
    const [cashOuts, setCashOuts] = useState(0);
    useEffect(() => {
        setWalletValue(0);
        getIpxWallet();
    },[dateRange]);

    const getIpxWallet = async () => {
        let storedProcedure = 'ipx_wallet';
        let params = {};
        if (dateRange.dateFrom && dateRange.dateTo) {
            params = {
                dateFrom: dateRange.dateFrom,
                dateTo: dateRange.dateTo
            };
            storedProcedure = 'ipx_wallet_range';
        } else {
            params = {};
        }
        
        await adminServices.storeProcedure2(storedProcedure, params).then((response)=>{
            if(response.status == 200){
                if (dateRange.dateFrom && dateRange.dateTo && Array.isArray(response.data)) {
                    const total = response.data.reduce((sum, item) => sum + Math.abs(item.interest_fee || 0), 0);
                    setWalletValue(total);
                    setFees(response.data[0].fees);
                    setMerchantOrders(response.data[0].merchantOrder);
                    setCashOuts(response.data[0].cashOuts);
                } else {
                    setWalletValue(response.data[0].interest_fee);
                    setFees(response.data[0].fees);
                    setMerchantOrders(response.data[0].merchantOrder);
                    setCashOuts(response.data[0].cashOuts);
                }
            }
        }).catch((error) => {
            if(error.status == 401){
                navigate('/');
            }

            if(error.status == 429){
                toast.error('Too many requests. will data will retry in 1 minute.');
                setTimeout(async ()=>{
                    await getIpxWallet();
                },60000);
            }

        })
    }


  return (
        <div className='card' style={{
            width: '100%',
            marginBottom: '20px',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
                    <div className='card-header' style={{
                        backgroundColor: '#f8f9fa',
                        borderBottom: '1px solid #e0e0e0',
                        padding: '15px',
                        textAlign: 'center'
                    }}>
                        <h5 style={{ margin: 0, color: '#333', fontWeight: 'bold' }}>IPX Wallet</h5>
                        <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>
                            All incoming funds of IPX
                        </p>
                    </div>
            <div className='card-body' style={{ padding: '20px', textAlign: 'center' }}>
                <h2 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: 'bold', 
                    color: '#333',
                    margin: '0 0 10px 0'
                }}>
                    {formatCurrency(walletValue)}
                </h2>
                <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                    Transactions Fee + Sales Payment
                </p>
                <div style={{ marginTop: '12px' }}>
                    <button
                        onClick={() => navigate('/ipx-transactions')}
                        style={{
                            background: '#007bff',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '6px 12px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                        onMouseOver={(e) => (e.target.style.background = '#0056b3')}
                        onMouseOut={(e) => (e.target.style.background = '#007bff')}
                    >
                        Show Details
                    </button>
                </div>

               <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }} className='mt-3'>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                    <h6 style={{ color: '#666', marginBottom: '5px' }}>Total Fees</h6>
                    <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#333', margin: '0 0 10px 0' }}>
                        {formatCurrency(fees || 0)}
                    </p>
                </div>
            
            <div style={{ flex: 1, textAlign: 'center' }}>
                <h6 style={{ color: '#666', marginBottom: '5px' }}>Orders & Transfers</h6>
                <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#333', margin: '0 0 10px 0' }}>
                    {formatCurrency(merchantOrders || 0)}
                </p>
                
            </div>
            
            <div style={{ flex: 1, textAlign: 'center' }}>
                <h6 style={{ color: '#666', marginBottom: '5px' }}>Cash Out Requests</h6>
                <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#333', margin: '0 0 10px 0' }}>
                    {formatCurrency(cashOuts || 0)}
                </p>
                
            </div>
        </div>
            </div>

            
        </div>  
  );

  };

export default IPXWalletCard;